import Client from '../HttpClient';

const baseUrl = '/gateway/kiwi-mgt/api/vs/tyro-ttp';

const listAuths = (merchantId) => {
	return Client.get(`${baseUrl}/merchants/${merchantId}/auths`, {});
};

const updateAuth = (merchantId, authId, locationId, locationName) => {
	return Client.put(`${baseUrl}/merchants/${merchantId}/auths/${authId}`, {
		locationId,
		locationName,
	});
};

const listMerchants = () => {
	return Client.get(`${baseUrl}/merchants`, {});
};

const fetchMerchant = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/merchants/${merchantId}`, {
		branchId,
	});
};

const listLocations = (tyroMerchantId) => {
	return Client.get(`${baseUrl}/merchants/${tyroMerchantId}/locations`, {});
};

const listReaders = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/merchants/${merchantId}/readers`, {
		branchId,
	});
};

const createReader = (merchantId, branchId, name) => {
	return Client.post(`${baseUrl}/merchants/${merchantId}/readers`, {
		branchId,
		name,
	});
};

export default {
	listAuths,
	updateAuth,
	listMerchants,
	fetchMerchant,
	listLocations,
	listReaders,
	createReader,
};
